/* eslint semi:0 */
/**
 * Manages fetch lifecycle via Redux actions.
 */
import { takeEvery } from 'redux-saga'
import { getResponseText, getJsonOrError } from '../../utils/fetch'
import { error } from '../console'
import { memoizeFirstCall } from '../../utils/fn'
import { call, put } from 'redux-saga/effects'
import { namespacedConsts } from '../../utils/object'
import { getApiEndpoints } from '../../application/api'
import pageDataObject from '../../application/pageDataObject'

export const FETCH_REQUEST_ACTION_TYPE = 'FETCH_REQUESTED'
const FETCH_SUFFIXES = namespacedConsts({
  FETCH: {
    SUCCESS: true,
    FAIL: true,
  },
})

export const getNameSpacedFetchActions = endpointName => {
  const namespacedActions = namespacedConsts({
    [endpointName]: FETCH_SUFFIXES,
  })
  return namespacedActions[endpointName]
}

export function getNamespacedFetchActionTypes(apiEndpointName) {
  const { API_ENDPOINT } = memoizeFirstCall('API_ENDPOINT', getApiEndpoints, apiEndpointName)
  // FIXME: in case of failure, return value shouldn't be false
  return API_ENDPOINT ? getNameSpacedFetchActions(apiEndpointName) : false
}

function defaultResponseTransformer(response = {}) {
  return 'data' in response ? response.data : response
}

export function* fetchDataSaga({
  payload: { url, dataTransformer, additionalState, endpointName, ignoreJsonResponse },
}) {
  const NAMESPACED_FETCH_ACTIONS = getNameSpacedFetchActions(endpointName)
  try {
    const fetchFn = ignoreJsonResponse ? getResponseText : getJsonOrError
    const response = yield call(fetchFn, url)
    if (response instanceof Error) {
      throw new Error(response)
    }
    const responseJson = defaultResponseTransformer(response)
    const data = dataTransformer ? dataTransformer(responseJson) : responseJson
    const state = additionalState ? { ...additionalState, ...data } : data
    yield put({ type: `${NAMESPACED_FETCH_ACTIONS.FETCH.SUCCESS}`, state })
  } catch (err) {
    error(`fetchSaga ${err}`)
    yield put({ type: `${NAMESPACED_FETCH_ACTIONS.FETCH.FAIL}`, error: err })
  }
}

export function getNoEndpointsErrorMessage(context) {
  const message = 'FETCH action types are undefined. Check pdo.config.api for available endpoints'
  error(message, {
    message,
    component: context,
    props: context.props,
    api: pageDataObject.get('config.api'),
  })
}

export function* watchFetchDataSaga() {
  yield* takeEvery(FETCH_REQUEST_ACTION_TYPE, fetchDataSaga)
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/application/sagas/fetchSaga.js